import { IPagination } from "src/app/shared/models/page.model";
import { ICategory } from "../models/categories.models";
import { Action, createReducer, on } from "@ngrx/store";
import * as categoriesActions  from "./categories.actions"

export interface CategoriesState {
  metadata: IPagination | null;
  categories: ICategory[];
  allCategories: ICategory[];
  loading: boolean;
  keyword: string
}

export const initialProductsState: CategoriesState = {
  metadata: null,
  categories: [],
  allCategories: [],
  loading: false,
  keyword: ''
}

const featureReducer = createReducer(
  initialProductsState,
  on(
    categoriesActions.FetchAllCategoriesSuccess,
    (state, action) => ({
      ...state,
      allCategories: action.categories.data,
    })
  ),
  on(
    categoriesActions.FetchCategoriesSuccess,
    (state, action) => ({
      ...state,
      categories: action.categories.data,
      metadata: action.categories.metadata
    })
  ),
  on(categoriesActions.AddCategorySuccess, (state, action) => ({
    ...state,
    allCategories: [...state.allCategories, ...action.categories as Array<ICategory>],
  })),
  on(categoriesActions.SetCategoriesLoader, (state, action) => ({
    ...state,
    loading: action.isLoading
  })),
  on(categoriesActions.SetCategoriesSearch, (state, action) => ({
    ...state,
    keyword: action.keyword
  }))
)

export function categoriesReducer(state: CategoriesState | undefined, action: Action) {
  return featureReducer(state, action);
}
